export const formatCronToReadable = (cron) => {
  if (!cron) return "-";

  // example: "14 14 * * 3"
  const [minute, hour, , , day] = cron.split(" ");

  const daysMap = {
    0: "Sunday",
    1: "Monday",
    2: "Tuesday",
    3: "Wednesday",
    4: "Thursday",
    5: "Friday",
    6: "Saturday",
  };

  // 24h → 12h conversion
  const h = Number(hour);
  const m = minute.padStart(2, "0");
  const period = h >= 12 ? "PM" : "AM";
  const hour12 = h % 12 || 12;

  return `${hour12}:${m} ${period},${daysMap[day]}`;
};
